import { queryOptions } from '@tanstack/react-query';
import { BLOG_QUERY_KEYS } from './keys';
import { blogAPIClient } from '../blogAPIClient';
import type { BlogPostSummaryRequest } from './types';

export const BLOG_QUERIES = {
  getBlogPostsSummary: (params?: BlogPostSummaryRequest) =>
    queryOptions({
      queryKey: BLOG_QUERY_KEYS.getBlogPostsSummary(params),
      queryFn: () => blogAPIClient.getBlogPostsSummary(params),
    }),
};
